module.exports = __webpack_public_path__ + "static/media/message.4a314175.svg";